<template>
  <div>
    <b-card>
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h3 class="mb-0">
            تفاصيل فريق العمل
          </h3>
          <b-card-text class="mb-0 text-muted">
            #{{ id }}
          </b-card-text>
        </div>
        <div>
          <b-button
            variant="outline-secondary"
            class="mr-1"
            :to="{ name: 'team_works' }"
          >
            رجوع
          </b-button>
          <b-button
            variant="primary"
            class="mr-1"
            :to="{ name: 'team_works_edit', params: { id } }"
          >
            تعديل
          </b-button>
          <b-button
            v-if="hasPermission && hasPermission('edit team_works')"
            variant="success"
            class="mr-1"
            @click="openAssignModal"
          >
            اضافة الي مشاريع
          </b-button>
          <b-button
            variant="danger"
            @click="confirmDelete"
          >
            حذف
          </b-button>
        </div>
      </div>
    </b-card>

    <b-card
      v-if="loadItem"
      class="text-center"
    >
      <b-spinner variant="primary" />
    </b-card>

    <b-card v-else-if="item">
      <b-row>
        <b-col
          cols="12"
          md="6"
        >
          <h5 class="mb-1">
            المسؤولين
          </h5>
          <ul class="list-unstyled mb-0">
            <li><strong> المهندس المسؤل:</strong> {{ employeeName(item.technical_responsible) }}</li>
            <li><strong>مسؤول الاتفاقية:</strong> {{ employeeName(item.office_agreement_responsible) }}</li>
            <li><strong>مسؤول المعاينة:</strong> {{ employeeName(item.office_inspection_responsible) }}</li>
            <li><strong>مسؤول عن الرسم:</strong> {{ employeeName(item.office_drawing_responsible) }}</li>
            <li><strong>QC:</strong> {{ employeeName(item.qc_responsible) }}</li>
            <li><strong>السائق:</strong> {{ employeeName(item.driver) }}</li>
          </ul>
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <h5 class="mb-1">
            الموقع
          </h5>
          <ul class="list-unstyled mb-0">
            <li><strong>المحافظة:</strong> {{ locationName(item.governorate) }}</li>
            <li><strong>الجهاز / الحي /المركز:</strong> {{ locationName(item.center) }}</li>
            <li><strong>الوحدة المحلية / الجهاز بالحي/ المدينة:</strong> {{ locationName(item.city) }}</li>
            <li><strong>القرية / التجمع:</strong> {{ locationName(item.district) }}</li>
            <li><strong>عزبة / نجع /منطقة:</strong> {{ locationName(item.village) }}</li>
          </ul>
        </b-col>
      </b-row>

      <hr class="my-2">

      <h5 class="mb-1">
        فريق المعاينة
      </h5>
      <b-table
        :items="inspectionRows"
        :fields="inspectionFields"
        small
        responsive
        striped
        hover
        show-empty
        empty-text="لا يوجد أعضاء"
      />

      <hr class="my-2">

      <b-row>
        <b-col
          cols="12"
          md="6"
        >
          <p class="mb-0">
            <strong>Created:</strong> {{ item.created_at || '-' }}
          </p>
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <p class="mb-0">
            <strong>Updated:</strong> {{ item.updated_at || '-' }}
          </p>
        </b-col>
      </b-row>
    </b-card>

    <b-modal
      id="assign-projects-modal"
      ref="assignProjectsModal"
      title="اضافة الي مشاريع"
      ok-only
      hide-footer
      centered
      no-close-on-backdrop
    >
      <b-form @submit.prevent="submitAssign">
        <b-row>
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group label="الجهاز / الحي /المركز *">
              <v-select
                v-model="assignForm.center_id"
                :options="centersOptions"
                :reduce="v => v.id"
                :get-option-label="o => o.name_ar || o.name || o.name_local"
                dir="rtl"
                :clearable="true"
              />
              <small
                v-if="assignFieldError('center_id')"
                class="text-danger"
              >{{ assignFieldError('center_id') }}</small>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group label="الوحدة المحلية / الجهاز بالحي/ المدينة">
              <v-select
                v-model="assignForm.city_id"
                :options="citiesOptions"
                :reduce="v => v.id"
                :get-option-label="o => o.name_ar || o.name || o.name_local"
                dir="rtl"
                :clearable="true"
                :disabled="!assignForm.center_id"
              />
              <small
                v-if="assignFieldError('city_id')"
                class="text-danger"
              >{{ assignFieldError('city_id') }}</small>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group label="القرية / التجمع">
              <v-select
                v-model="assignForm.district_id"
                :options="districtsOptions"
                :reduce="v => v.id"
                :get-option-label="o => o.name_ar || o.name || o.name_local"
                dir="rtl"
                :clearable="true"
                :disabled="!assignForm.city_id"
              />
              <small
                v-if="assignFieldError('district_id')"
                class="text-danger"
              >{{ assignFieldError('district_id') }}</small>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group label="عزبة / نجع /منطقة">
              <v-select
                v-model="assignForm.village_id"
                :options="villagesOptions"
                :reduce="v => v.id"
                :get-option-label="o => o.name_ar || o.name || o.name_local"
                dir="rtl"
                :clearable="true"
                :disabled="!assignForm.district_id"
              />
              <small
                v-if="assignFieldError('village_id')"
                class="text-danger"
              >{{ assignFieldError('village_id') }}</small>
            </b-form-group>
          </b-col>
        </b-row>

        <div class="d-flex justify-content-end">
          <b-button
            variant="outline-secondary"
            class="mr-1"
            @click="closeAssignModal"
          >
            Close
          </b-button>
          <b-button
            variant="primary"
            type="submit"
            :disabled="loadAssignProjects"
          >
            <b-spinner
              v-if="loadAssignProjects"
              small
              class="mr-50"
            />
            Assign
          </b-button>
        </div>
      </b-form>

      <div
        v-if="assignSummary"
        class="mt-2"
      >
        <hr class="my-2">
        <h5 class="mb-1">
          Summary
        </h5>
        <ul class="list-unstyled mb-0">
          <li><strong>matched_projects_count:</strong> {{ assignSummary.matched_projects_count }}</li>
          <li><strong>assigned_projects_count:</strong> {{ assignSummary.assigned_projects_count }}</li>
          <li><strong>assigned_technical_responsible_id:</strong> {{ assignSummary.assigned_technical_responsible_id }}</li>
        </ul>

        <div
          v-if="assignSummary.matched_project_ids && assignSummary.matched_project_ids.length"
          class="mt-1"
        >
          <b-button
            v-b-toggle.matched-ids-collapse
            size="sm"
            variant="outline-info"
          >
            Show matched_project_ids ({{ assignSummary.matched_project_ids.length }})
          </b-button>
          <b-collapse
            id="matched-ids-collapse"
            class="mt-1"
          >
            <b-card class="mb-0">
              <div style="max-height: 200px; overflow: auto;">
                <code>{{ assignSummary.matched_project_ids.join(', ') }}</code>
              </div>
            </b-card>
          </b-collapse>
        </div>
      </div>
    </b-modal>

    <!-- Activity Logs Section -->
    <b-card
      v-if="hasPermission('view activity_logs')"
      class="mt-2"
    >
      <b-card-header>
        <h5 class="mb-0">
          سجل النشاطات
        </h5>
      </b-card-header>
      <b-card-body>
        <ActivityLogs
          :model-type="'team-work'"
          :model-id="Number(id)"
          :show-filters="true"
          :per-page="15"
        />
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardText, BRow, BCol, BButton, BSpinner, BTable, BModal, BForm, BFormGroup, BCollapse, BCardHeader, BCardBody,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import ActivityLogs from '@/components/ActivityLogs.vue'

export default {
  name: 'TeamWorkDetails',
  components: {
    BCard, BCardText, BCardHeader, BCardBody, BRow, BCol, BButton, BSpinner, BTable, BModal, BForm, BFormGroup, BCollapse, vSelect, ActivityLogs,
  },
  computed: {
    ...mapGetters({
      item: 'teamWorks/item',
      loadItem: 'teamWorks/loadItem',
      loadAssignProjects: 'teamWorks/loadAssignProjects',
      centers: 'settings/centers',
      cities: 'settings/cities',
      districts: 'settings/districts',
      villages: 'settings/villages',
    }),
    id() {
      return this.$route.params.id
    },
    inspectionRows() {
      return this.item && Array.isArray(this.item.inspection_teams) ? this.item.inspection_teams : []
    },
    centersOptions() {
      return this.centers && this.centers.data ? this.centers.data : []
    },
    citiesOptions() {
      return this.cities && this.cities.data ? this.cities.data : []
    },
    districtsOptions() {
      return this.districts && this.districts.data ? this.districts.data : []
    },
    villagesOptions() {
      return this.villages && this.villages.data ? this.villages.data : []
    },
  },
  data() {
    return {
      inspectionFields: [
        { key: 'id', label: '#' },
        { key: 'employee_code', label: 'Code' },
        { key: 'full_name', label: 'الاسم' },
      ],
      assignForm: {
        center_id: null,
        city_id: null,
        district_id: null,
        village_id: null,
      },
      assignErrors: {},
      assignSummary: null,
    }
  },
  watch: {
    '$route.params.id': function () {
      this.fetch()
    },
    'assignForm.center_id': function (v) {
      this.assignForm.city_id = null
      this.assignForm.district_id = null
      this.assignForm.village_id = null
      if (v) this.$store.dispatch('settings/listCities', { query: { center_id: v } })
    },
    'assignForm.city_id': function (v) {
      this.assignForm.district_id = null
      this.assignForm.village_id = null
      if (v) this.$store.dispatch('settings/listDistricts', { query: { city_id: v } })
    },
    'assignForm.district_id': function (v) {
      this.assignForm.village_id = null
      if (v) this.$store.dispatch('settings/listVillages', { query: { district_id: v } })
    },
  },
  mounted() {
    this.fetch()
  },
  methods: {
    employeeName(emp) {
      return emp && emp.full_name ? emp.full_name : '-'
    },
    locationName(loc) {
      if (!loc) return '-'
      return loc.name_ar || loc.name || loc.name_local || '-'
    },
    fetch() {
      this.$store.dispatch('teamWorks/fetchItem', { id: this.id }).catch(err => {
        const msg = (err && err.response && err.response.data && err.response.data.message) || (err && err.message) || 'تعذر تحميل البيانات'
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'خطأ', icon: 'AlertTriangleIcon', variant: 'danger', text: msg,
          },
        })
      })
    },
    openAssignModal() {
      this.assignErrors = {}
      this.assignSummary = null
      this.assignForm = {
        center_id: null, city_id: null, district_id: null, village_id: null,
      }
      // load centers list (backend may allow without governorate_id)
      this.$store.dispatch('settings/listCenters', { query: {} })
      this.$refs.assignProjectsModal.show()
    },
    closeAssignModal() {
      this.$refs.assignProjectsModal.hide()
    },
    assignFieldError(key) {
      const v = this.assignErrors && this.assignErrors[key]
      return Array.isArray(v) ? v[0] : v || null
    },
    submitAssign() {
      this.assignErrors = {}

      if (!this.assignForm.center_id) {
        this.assignErrors = { center_id: ['center_id is required'] }
        return
      }

      const payload = {
        center_id: this.assignForm.center_id,
        district_id: this.assignForm.district_id || null,
        city_id: this.assignForm.city_id || null,
        village_id: this.assignForm.village_id || null,
      }

      this.$store
        .dispatch('teamWorks/assignProjects', { id: this.id, data: payload })
        .then(res => {
          this.$toast({
            component: ToastificationContent,
            props: { title: 'Assigned successfully', icon: 'CheckIcon', variant: 'success' },
          })
          const summary = (res && res.data) ? res.data : res
          // support both {data:{...}} and plain {...}
          this.assignSummary = (summary && summary.data) ? summary.data : summary
        })
        .catch(err => {
          const status = err && err.response ? err.response.status : null
          if (status === 403) {
            this.$toast({
              component: ToastificationContent,
              props: { title: 'No permission', icon: 'AlertTriangleIcon', variant: 'danger' },
            })
            return
          }
          if (status === 422) {
            this.assignErrors = (err.response && err.response.data && err.response.data.errors) ? err.response.data.errors : {}
            return
          }
          this.$toast({
            component: ToastificationContent,
            props: { title: 'Something went wrong', icon: 'AlertTriangleIcon', variant: 'danger' },
          })
        })
    },
    confirmDelete() {
      this.$swal({
        title: 'هل أنت متأكد؟',
        text: 'سيتم حذف فريق العمل!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'نعم، احذف!',
        cancelButtonText: 'إلغاء',
      }).then(result => {
        if (result.isConfirmed) {
          this.$store
            .dispatch('teamWorks/delete', { id: this.id })
            .then(() => {
              this.$router.push({ name: 'team_works' })
            })
            .catch(err => {
              const msg = (err && err.response && err.response.data && err.response.data.message) || (err && err.message) || 'تعذر الحذف'
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'خطأ', icon: 'AlertTriangleIcon', variant: 'danger', text: msg,
                },
              })
            })
        }
      })
    },
  },
}
</script>
